var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import RatingStar from './components/RatingStar/RatingStar';
import { RatingTypes } from './type';
function Rating(props) {
    switch (props.type) {
        case RatingTypes.star:
        case RatingTypes.slide:
        case RatingTypes.button:
        default:
            return React.createElement(RatingStar, __assign({}, props));
    }
}
export default Rating;
